import React from 'react';
import { PaymentMethods } from './PaymentMethods';
export function Footer() {
  return <footer className="bg-white py-16 border-t border-ink/5" data-id="element-507">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-508">
        <div className="flex flex-col md:flex-row justify-between items-center gap-8 mb-12" data-id="element-509">
          {/* Brand */}
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-510">
            <div className="flex items-center gap-2.5" data-id="element-511">
              <img src="https://cdn.magicpatterns.com/uploads/qSJmtYJXdqJECu9iFvoXiT/ChatGPT_Image_20_may_2026,_11_40_53_p.m..png" alt="Recetas PowerFit" className="w-11 h-11 rounded-full object-cover flex-shrink-0" data-id="element-512" />
              <span className="text-2xl font-extrabold tracking-tight leading-none" data-id="element-513">
                <span style={{
                color: '#2F5233'
              }} data-id="element-514">
                  Recetas Power
                </span>
                <span style={{
                color: '#7CB342'
              }} data-id="element-515">
                  Fit
                </span>
              </span>
            </div>
            <p className="text-sm text-ink-light mt-3 font-light" data-id="element-516">
              Transformando hábitos, una receta a la vez.
            </p>
          </div>

          {/* Payment methods */}
          <PaymentMethods data-id="element-517" />
        </div>

        <div className="flex justify-center pt-8 border-t border-ink/5" data-id="element-518">
          <p className="text-xs text-ink-light font-light text-center" data-id="element-519">
            © {new Date().getFullYear()} Recetas PowerFit. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}